<template>
    <div v-if="pending">
        <div class="d-flex justify-content-center loading-center">
            <div class="spinner-border" role="status">
                <span class="sr-only">Loading...</span>
            </div>
        </div>
    </div>
	<div v-else class="container py-5">
        <h2>{{ $t('curveDetail') }}</h2>
        <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
                <li class="breadcrumb-item">
                    <RouterLink to="/modelings">
                        {{ $t('home') }}
                    </RouterLink>
                </li>
                <li class="breadcrumb-item">
                    <RouterLink :to="{ name: 'modeling', params: { id: this.$route.params.id } }">
                        {{ modelingName || $t('modelings') }}
                    </RouterLink>
                </li>
                <li class="breadcrumb-item">
                    <RouterLink :to="'/modeling/'+ this.$route.params.id + '/assettype/' + this.$route.params.assetTypeId" >
                        {{ assetTypeName || $t('assetType') }}
                    </RouterLink>
                </li>
                <li class="breadcrumb-item">{{ data.name }}</li>
            </ol>
        </nav>  
        <!-- <h3 class="text-center mb-4">
            <RouterLink :to="'/modeling/' + this.$route.params.id + '/curveinfo/' + this.$route.params.curveId">
                <button class="btn btn-secondary float-end ">
                    {{ $t('detail') }}
                </button>
            </RouterLink>
            <template v-if="isUserAdmin">
                <button class="btn btn-secondary float-end me-2" @click="showAnalyseCurve = true">
                    {{ $t('runSimulation') }}
                </button>
                <button class="btn btn-secondary float-end me-2" @click="showValidateCurve = true">
                    {{ $t('validate') }}
                </button>
            </template>
        </h3> -->
        <div class="row mb-4">
            <div class="mb-3 col-md-4">
                <label class="form-label" for="name" required>{{ $t('name') }}</label>
                <input v-model="data.name" type="text" class="form-control" id="name" >
            </div>
            <div class="mb-3 col-md-8">
                <label class="form-label" for="description" required>{{ $t('description') }}</label>
                <input v-model="data.description" type="text" class="form-control" id="description" >
            </div>
        </div>
        <div class="row mb-4">
            <div class="mb-3 col-md-4">
                <label class="form-label" for="coefficientAttribute" required>{{ $t('coefficientAttribute') }}</label>
                <select id="coefficientAttribute" class="form-select" v-model="data.coefficientAttribute">
                    <option disabled>{{ $t('select') }}</option>
                    <template v-if="datasetHeaders.length > 0" >
                        <option v-for="(datasetHeader, i) in datasetHeaders" :key="i"  v-bind:value="datasetHeader.name">{{ datasetHeader.alias }}</option>
                    </template>
                </select> 
            </div>
            <div class="mb-3 col-md-4">
                <label class="form-label">&nbsp;</label>
                <div class="form-check">
                    <input class="form-check-input" type="checkbox" v-model="data.coefficientForecastOnly"  id="coefficientForecastOnly" checked>
                    <label class="form-check-label" for="coefficientForecastOnly">
                        {{ $t('coefficientForecastOnly') }}
                    </label>
                </div>
            </div>
        </div>
        <button class="fa fa-eye btn btn-outline-primary float-end" @click="showTableFunction"></button>
        <div class="mb-3" v-if="showTable">
            <h4>{{ $t('curveRange') }}</h4>
            <table class="table">
                <thead>
                    <tr>
                        <th scope="col"></th>
                        <th scope="col">{{ $t('startAge') }}</th>
                        <th scope="col">{{ $t('endAge') }}</th>
                        <th scope="col">{{ $t('startValue') }}</th>
                        <th scope="col">{{ $t('endValue') }}</th>
                    </tr>
                </thead>
                <tbody> 
                    <tr v-for="(curveRange, i) in data.curveRanges" class="align-middle"  :key="i">
                        <th scope="row"><i class="fa fa-remove" @click="removeCurveRange(i)"></i></th>
                        <td>
                            <input v-model="curveRange.startAge" disabled type="number" class="form-control" :id="'startAge_' + i">
                        </td>
                        <td>
                            <input v-model="curveRange.endAge" :max="data.lifespan" @input="updateCurveAgeStart(curveRange.endAge, i)" type="number" class="form-control" :id="'endAge_' + i">
                        </td>
                        <td>
                            <input v-model="curveRange.startValue" :disabled="i > 0" type="number" class="form-control" :id="'startValue_' + i">
                        </td>
                        <td>
                            <input v-model="curveRange.endValue" @input="updateCurveStartValue(curveRange.endValue, i)"  type="number" class="form-control" :id="'endValue_' + i">
                        </td>
                    </tr>
                </tbody>
            </table>
            <button class="btn btn-secondary w-25 mx-auto d-block" @click="addCurveRange"><i class="fa-solid fa-plus"></i></button>
        </div>
        <div v-else class="mb-3">
            <h4>{{ $t('curveRangeChart') }}</h4>
            <apexchart class="d-flex justify-content-center" type="line" width="800px" :options="chartOptions" :series="series"></apexchart>
        </div>
        <div class="mb-3">
            <h4 class="mb-3">{{ $t('curveFilters') }} </h4>
            <table class="table">
                <thead>
                    <tr>
                        <th scope="col"></th>
                        <th scope="col">{{ $t('name') }}</th>
                        <th scope="col">{{ $t('sign') }}</th>
                        <th scope="col">{{ $t('number') }}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(curveFilter, i) in data.curveFilters" class="align-middle"  :key="i" >
                        <th scope="row"><i class="fa fa-remove" @click="removeCurveFilter(i)"></i></th>
                        <td>
                            <select :id="'name_' + i" class="form-select" v-model="curveFilter.name">
                                <option disabled>{{ $t('select') }}</option>
                                <template v-if="datasetHeaders.length > 0" >
                                    <option v-for="(datasetHeader, i) in datasetHeaders" :key="i"  v-bind:value="datasetHeader.name">{{ datasetHeader.alias }}</option>
                                </template>
                            </select>
                        </td>
                        <td>
                            <select v-model="curveFilter.sign" class="form-select"  :id="'sign_' + i"> 
                                <option value="=">=</option>
                                <option value=">">&gt;</option>
                                <option value="<">&lt;</option>
                                <option value=">=">&gt;=</option>
                                <option value="<=">&lt;=</option>
                            </select>
                        </td>
                        <td>
                            <input v-model="curveFilter.number" type="number" class="form-control" :id="'number_' + i">
                        </td>
                    </tr>
                </tbody>
            </table>
            <button class="btn btn-secondary w-25 mx-auto d-block"  @click="addCurveFilter"><i class="fa-solid fa-plus"></i></button>
        </div>
        <div class="mb-3">
            <h4 class="mb-3">{{ $t('curveActivityEffects') }} </h4>
            <table class="table">
                <thead>
                    <tr>
                        <th scope="col"></th>
                        <th scope="col">{{ $t('name') }}</th>
                        <th scope="col">{{ $t('effect') }}</th> 
                        <th scope="col">{{ $t('changeToCurve') }}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(curveActivityEffect, i) in data.curveActivityEffects" class="align-middle"  :key="i" >
                        <th scope="row"><i class="fa fa-remove" @click="removeCurveActivityEffect(i)"></i></th>
                        <td>
                            <select :id="'activityId_' + i" class="form-select" v-model="curveActivityEffect.activityId">
                                <option disabled>{{ $t('select') }}</option>
                                <template v-if="activityList.length > 0" >
                                    <option v-for="(activity, i) in activityList" :key="i" v-bind:value="activity.id">{{ activity.name }}</option>
                                </template>
                            </select>
                        </td>
                        <td>
                            <div class="input-group">
                                <input v-model="curveActivityEffect.effect" type="number" class="form-control" :id="'effect_' + i">
                                <select :id="'effecttype_' + i" class="form-select" v-model="curveActivityEffect.effectType" >
                                    <option value="0">{{ $t('Absolute') }}</option>
                                    <option value="1">{{ $t('Relative') }}</option>
                                    <option value="2">{{ $t('Differential') }}</option>
                                </select>
                            </div>
                        </td>
                        <td>
                            <select v-model="curveActivityEffect.changeToCurveId" class="form-select"  :id="'changeToCurve_' + i"> 
                                <option value=""></option>
                                <template v-if="curveList.length > 0" >
                                    <option v-for="(curve, i) in curveList" :key="i" v-bind:value="curve.id">{{ curve.name }}</option>
                                </template>
                            </select>
                        </td>
                    </tr>
                </tbody>
            </table>
            <button class="btn btn-secondary w-25 mx-auto d-block" @click="addCurveActivityEffect"><i class="fa-solid fa-plus"></i></button>
        </div>
        <div class="d-grid gap-2 d-md-flex">
            <template v-if="isUserAdmin">
                <button type="button" class="btn btn-primary" @click="onSubmit">{{ $t('save') }}</button>
                <button type="button" class="btn btn-danger"  @click="showDeleteCurve">{{ $t('delete') }}</button>
            </template>
            <button type="button" class="btn btn-secondary" @click="$router.push({ path: `/modeling/${this.$route.params.id}/assettype/${this.$route.params.assetTypeId}` })">{{ $t('back') }}</button>
        </div>
        <CurveDeleteModal v-if="showCurveDeleteModal" @reload="$router.push({ path: `/modeling/${this.$route.params.id}/assettype/${this.$route.params.assetTypeId}` })" @closeDeleteDialog="showCurveDeleteModal = false"/>
    </div>
</template>

<script>
import AssetTypeApi from "../../api/server/assetType.js";
import ActivityApi from "../../api/server/activity.js";
import CurveApi from "../../api/server/curve.js";
import DatasetApi from "../../api/server/dataset.js";
import ModelingApi from "../../api/server/modeling";
import ParameterApi from "../../api/server/parameter.js";
import CurveDeleteModal from './CurveDeleteModal.vue';
import { CheckIfUserIsEditor } from '../../authCache';

export default {
    name: "curvedetail",
    watch: {
        $route: "requestData",
    },
    mounted() {
        this.requestData();
    },
    components: {
        CurveDeleteModal
    },
    methods: {
        async onSubmit() {
            if(this.data.name.length > 0) {
                await CurveApi.curveUpdate(this.$route.params.id, this.data);
                if(!this.checkCurveFilters())
                    this.showFiltersWarning();
                else     
                    this.showSuccess();
            } else {
                this.showEmptyNameError();
            }
        },
        async requestData() {
            this.pending = true;
            this.isUserAdmin = await CheckIfUserIsEditor();

            this.data = await CurveApi.curveDetail(this.$route.params.id, this.$route.params.curveId);

            this.parameter = await ParameterApi.parameterDetail(this.$route.params.id, this.data.parameterId);
            var assetType = await AssetTypeApi.assetTypeDetail(this.$route.params.id, this.parameter.assetTypeId);
            this.assetTypeName = assetType.name;

            var dataset = await DatasetApi.datasetDetail(this.$route.params.id, assetType.datasetId);

            var activityList = await ActivityApi.activityList(this.$route.params.id);
            this.activityList = activityList.filter(a => a.assetTypeId == this.$route.params.assetTypeId);

            var datasetContent = JSON.parse(dataset.content);
            this.datasetHeaders = datasetContent["headers"];

            var modeling = await ModelingApi.modelingDetail(this.$route.params.id);
            this.modelingName = modeling.name;
            
            var curveList = await CurveApi.curveList(this.$route.params.id);
            this.curveList = curveList.filter(a => a.parameterId == this.data.parameterId && a.id != this.$route.params.curveId);

            for(var i in this.data.curveFilters) {
                var attr = this.data.curveFilters[i];
                if(this.datasetHeaders.findIndex(d => d.name == attr.name) < 0 && this.missingDatasetFilterHeaders.findIndex(d => d.name == attr.name) < 0) {
                    this.missingDatasetFilterHeaders.push({ name: attr.name, alias: attr.name });
                }
            }

            // for(var i in this.data.curveActivityEffects) {
            //     var attr = this.data.curveActivityEffects[i];
            //     if(this.datasetHeaders.findIndex(d => d.name == attr.name) < 0 && this.missingDatasetFilterHeaders.findIndex(d => d.name == attr.name) < 0) {
            //         this.missingDatasetFilterHeaders.push({ name: attr.name, alias: attr.name });
            //     }
            // }


            this.pending = false;
        },
        showTableFunction() {
            this.generateGraph();
            this.showTable = !this.showTable;
        },
        generateGraph() {
            let seriesData = [];

            for (let range of this.data.curveRanges) {
                seriesData.push({ x: range.startAge, y: range.startValue });
                seriesData.push({ x: range.endAge, y: range.endValue });
            }
            
            this.series = [{
                name: "Value",
                data: seriesData
            }];
        },
        removeCurveFilter(rowIndex) {
            this.data.curveFilters.splice(rowIndex, 1);
        },
        addCurveFilter() {
            this.data.curveFilters.push({  
                name: "",
                sign: "=",
                number: 0
            })
        },
        removeCurveActivityEffect(rowIndex) {
            this.data.curveActivityEffects.splice(rowIndex, 1);
        },
        addCurveActivityEffect() {
            this.data.curveActivityEffects.push({  
                effect: 0,
                effectType: 0,
                changeToCurveId: 0
            })
        },
        updateCurveAgeStart(value, i) {
            var range = this.data.curveRanges[i+1];
            if(range) {
                range.startAge = value;
            }
        },
        updateCurveStartValue(value, i) {
            var range = this.data.curveRanges[i+1];
            if(range) {
                range.startValue = value;
            }
        },
        removeCurveRange(rowIndex) {
            this.data.curveRanges.splice(rowIndex, 1);
        },
        addCurveRange() {
            this.data.curveRanges.push({  
                description: "",
                startAge: this.getMinStartAge(),
                endAge: 0,
                startValue: this.getMinStartValue(),
                endValue: 0.0
            })
        },
        getMinStartAge() {
            var minStartAge = 0;
            if(this.data.curveRanges.length > 0)
            minStartAge = this.data.curveRanges[this.data.curveRanges.length -1].endAge;

            return minStartAge;
        },
        getMinStartValue() {
            var minStartValue = 0;
            if(this.data.curveRanges.length > 0)
            minStartValue = this.data.curveRanges[this.data.curveRanges.length -1].endValue;

            return minStartValue;
        },
        showDeleteCurve() {
            this.curveToDeleteId = this.data.id;
            this.showCurveDeleteModal = true;
        },
        checkCurveFilters() {
            for(var i in this.data.curveFilters) {
                var attr = this.data.curveFilters[i];
                if(this.datasetHeaders.findIndex(d => d.name == attr.name) < 0 || attr.name == "") 
                    return false;
            }

            return true;
        },
    },
    notifications: {
        showSuccess: {
            title: 'success',
            message: 'curveUpdated',
            type: 'success'
        },
        showActivityEffectsWarning: { 
            title: 'warning',
            message: 'curveActivityEffectsWarning',
            type: 'warn'
        },
        showFiltersWarning: { 
            title: 'warning',
            message: 'curveFiltersWarning',
            type: 'warn'
        },
        showError: {
            title: 'error',
            message: 'curveErrorUpdate',
            type: 'error'
        },
        showEmptyNameError: { 
            title: 'error',
            message: 'emptyName',
            type: 'error'
        }
    },
    data() {
        return {
            parameter: {},
            datasetHeaders: [],
            missingDatasetFilterHeaders: [],
            data: {
                name: "",
                id: 0,
                forecastId: 0,
                curveGroup: [],
                curvePackage: [],
                curveLimit: []
            },
            showCurveDeleteModal: false,
            showAnalyseCurve: false,
            showValidateCurve: false,
            pending: true,
            modelingName: "",
            showTable: true,
            curveList: [],
            curveToDeleteId: 0,
            isUserAdmin: false,
            activityList: [],
            series: [],
            chartOptions: {
                chart: {
                    type: 'line',
                    animations: {
                        enabled: false
                    },
                    height: 350,
                    toolbar: {
                        show: false
                    }
                },
                xaxis: {
                    title: {
                        text: 'Age',
                    }
                },
                yaxis: {
                    title: {
                        text: 'Value',
                    },
                },
            }
        }
    }
};
</script>